import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/lib/images";
import MaskedLines from "@/components/motion/MaskedLines";

export default function Hero({ onBuy, onHow }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], [0, 120]);
  const sparkY = useTransform(scrollYProgress, [0, 1], [0, -60]);

  return (
    <section ref={ref} id="producto" className="relative bg-[#2E9EF0] border-b-2 border-[#12263A] overflow-hidden">
      {/* flat concentric rounded-square "spotlight" behind product */}
      <motion.div style={{ y: sparkY }} className="pointer-events-none absolute -right-24 top-10 hidden lg:block" aria-hidden="true">
        <div className="w-[520px] h-[520px] border-2 border-[#12263A]/30" style={{ borderRadius: "31%" }} />
      </motion.div>

      <div className="relative max-w-6xl mx-auto px-5 pt-16 pb-20 md:pt-24 md:pb-28 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <motion.span
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-block text-[11px] font-bold uppercase tracking-[0.16em] text-[#12263A] bg-[#FFC533] border-2 border-[#12263A] rounded-full px-4 py-1"
          >
            Reloj GPS para niños
          </motion.span>

          <MaskedLines
            lines={["Siempre cerca,", "aunque no estés."]}
            delay={0.15}
            className="mt-6 text-[#12263A] font-black leading-[1.0] text-4xl sm:text-5xl lg:text-[68px]"
            style={{ letterSpacing: "-0.02em" }}
          />

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.5 }}
            className="mt-6 text-[17px] leading-[1.6] text-[#12263A] max-w-md"
          >
            Sabes dónde está. Siempre. Kiddio le da a tu hijo libertad para explorar y a ti,
            la tranquilidad de tenerle a un toque de distancia.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.62 }}
            className="mt-8 flex flex-wrap gap-3"
          >
            <button
              onClick={onBuy}
              data-testid="hero-buy-btn"
              className="px-7 py-4 rounded-[20px] bg-[#12263A] text-white border-2 border-[#12263A] font-bold hover:bg-transparent hover:text-[#12263A] transition-colors active:translate-y-0.5"
            >
              Comprar
            </button>
            <button
              onClick={onHow}
              data-testid="hero-how-btn"
              className="px-7 py-4 rounded-[20px] bg-transparent text-[#12263A] border-2 border-[#12263A] font-bold hover:bg-[#12263A] hover:text-[#2E9EF0] transition-colors active:translate-y-0.5"
            >
              Ver cómo funciona
            </button>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <motion.div
            style={{ y: imgY }}
            className="border-2 border-[#12263A] overflow-hidden bg-white"
            initial={{ borderRadius: "32px" }}
          >
            <img
              src={IMAGES.hero}
              alt="Niño montando en bici al aire libre"
              className="w-full h-[380px] md:h-[480px] object-cover"
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
